<template>
  <div :class="$style.wrapper" @mousedown="plus" @mouseup="minus" :style="{ zIndex: zIndex }">
    <slot />
  </div>
</template>
<script>
import { TweenLite } from 'gsap'
import interact from 'interactjs'

const moveElement = (el, x, y) => {
  el.style.transition = 'none'

  TweenLite.to(el, { duration: 0.1, x, y })

  el.setAttribute('data-x', x)
  el.setAttribute('data-y', y)
}

export default {
  name: 'draggable',
  data: () => ({
    zIndex: 5,
  }),
  methods: {
    plus() {
      this.zIndex += 2
    },
    minus() {
      this.zIndex -= 2
    },
  },
  mounted() {
    interact(this.$el)
      .draggable({
        inertia: false,
        listeners: {
          move(event) {
            const { target: card } = event

            const x = (parseFloat(card.getAttribute('data-x')) || 0) + event.dx
            const y = (parseFloat(card.getAttribute('data-y')) || 0) + event.dy

            moveElement(card, x, y)
          },
        },
      })
  },
  beforeDestroy() {
    interact(this.$el).unset()
  },
}
</script>
<style lang="scss" module>
.wrapper {
  cursor: move;
  touch-action: none;
  position: relative;
}
</style>
